var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_c('help-popup-component',{attrs:{"title":'',"content":''}}),_c('VueApexCharts',{attrs:{"type":"bar","height":"350","options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }